import { render, staticRenderFns } from "./KETWidgetTasks.vue?vue&type=template&id=237d6f85&"
import script from "./KETWidgetTasks.vue?vue&type=script&lang=js&"
export * from "./KETWidgetTasks.vue?vue&type=script&lang=js&"
import style0 from "./KETWidgetTasks.vue?vue&type=style&index=0&id=237d6f85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports